<template>
  <div
    class="tooltip-parent"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
    @click="onClick"
  >
    <slot></slot>
    <transition name="fade">
      <div
        ref="tooltip"
        :class="['tooltip-content', calcPosition, customClass]"
        v-if="isShow"
        v-click-outside="onClickOutside"
      >
        <slot name="content">{{ label }}</slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Tooltip",

  data() {
    return {
      isShow: false,
      calcPosition: this.position
    };
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "top",
      validator: function(value) {
        return ["left", "right", "bottom", "top"].includes(value);
      }
    },
    clickable: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ""
    }
  },
  methods: {
    onMouseEnter() {
      if (this.clickable) return;
      this.isShow = true;
      this.setPosition();
    },
    onMouseLeave() {
      if (this.clickable) return;
      this.isShow = false;
      this.resetPosition();
    },
    onClick() {
      if (!this.clickable) return;
      this.isShow = true;
      this.setPosition();
      this.$emit("open");
    },
    onClickOutside() {
      if (!this.clickable) return;
      if (this.isShow) {
        this.isShow = false;
        this.resetPosition();
        this.$emit("close");
      }
    },
    setPosition() {
      this.$nextTick(() => {
        const tooltip = this.$refs.tooltip;
        if (!tooltip) return;

        const tooltipRect = tooltip.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        if (this.position === "top") {
          if (tooltipRect.top < 0) {
            this.calcPosition = "bottom";
          } else {
            this.calcPosition = "top";
          }
        } else if (this.position === "bottom") {
          if (tooltipRect.bottom > viewportHeight) {
            this.calcPosition = "top";
          } else {
            this.calcPosition = "bottom";
          }
        }
      });
    },
    resetPosition() {
      this.calcPosition = this.position;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/media";
.tooltip-parent {
  position: relative;
  cursor: pointer;
  width: max-content;
}
.tooltip-content {
  position: absolute;
  z-index: 15;
  font-size: 12px;
  color: #000000;
  background-color: #ffffff;
  box-sizing: border-box;
  width: max-content;
  max-width: 500px;
  padding: 10px 15px;
  text-align: left;
  border: 1px solid #ccc;
  border-radius: 2px;
  @include respond-down(xs) {
    max-width: 90vw;
  }

  &::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
  }
  &::before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    z-index: -1;
  }
  &.bottom {
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 10px;
    &::after {
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-width: 0 8px 8px 8px;
      border-color: transparent transparent white transparent;
    }
    &::before {
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-width: 0 9px 9px 9px;
      border-color: transparent transparent #ccc transparent;
    }
  }
  &.top {
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 10px;
    &:after {
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-width: 8px 8px 0 8px;
      border-color: white transparent transparent transparent;
    }
    &::before {
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-width: 9px 9px 0 9px;
      border-color: #ccc transparent transparent transparent;
    }
  }
  &.right {
    top: 50%;
    left: 100%;
    transform: translateY(-50%);
    margin-left: 10px;
    &::after {
      top: 50%;
      right: 100%;
      transform: translateY(-50%);
      border-width: 8px 8px 8px 0;
      border-color: transparent white transparent transparent;
    }
    &::before {
      top: 50%;
      right: 100%;
      transform: translateY(-50%);
      border-width: 9px 9px 9px 0;
      border-color: transparent #ccc transparent transparent;
    }
  }
  &.left {
    top: 50%;
    right: 100%;
    transform: translateY(-50%);
    margin-right: 10px;
    &::after {
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      border-width: 8px 0 8px 8px;
      border-color: transparent transparent transparent white;
    }
    &::before {
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      border-width: 9px 0 9px 9px;
      border-color: transparent transparent transparent #ccc;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
